/** Cost and margin alerts, shown inline where a supplier's cost is entered (module marginAlerts). */
export default {
  'margin.costUp': 'Cost up {pct}%: {old} → {new}.',
  'margin.marginDrop': 'Margin at {price}: {old}% → {new}%.',
  'margin.suggest': 'To keep {pct}%, sell at {price}.',
  'margin.suggestMrp': 'Keeping {pct}% needs more than the MRP; at the MRP ({price}) the margin is {at}%.',
  'margin.atMrp': 'Already selling at the MRP, so the price cannot rise to keep {pct}%. Ask the supplier for a better rate.',
  'margin.belowCost': 'This cost is at or above the selling price: every sale loses money.',
  'margin.review': 'Review price',
  'margin.advice': 'Prices never change on their own.',
} as const;
